import { IIntegration, IntegrationType } from '@principle-theorem/integrations';
import { IBaseSMSIntegrationData } from './sms-integration';

export interface IViaApiIntegrationData extends IBaseSMSIntegrationData {
  enabled: boolean;
}

export function isViaApiIntegration(
  item: IIntegration
): item is IIntegration<IViaApiIntegrationData> {
  return item.type === IntegrationType.ViaApi;
}
